export default __webpack_public_path__ + "static/media/map-legend_-grey.28e04f7a.png";